import React, { useEffect, useState, useRef, ReactNode } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import Badge from 'react-bootstrap/Badge';
import Alert from 'react-bootstrap/Alert';
import toast from 'react-hot-toast';

import { glClassificationApi } from '../../../resources/hooks/api/glClassificationApi';
import { MONTHS, URLS } from '../../../resources/constants'
import { getBranch } from '../../../store/user/selectors'
import { getFirstLoginStatus } from '../../../store/settings/selectors'

import '../GlClassification.css'

interface Props {

}

const ExpenseGlClassificationStatus: React.FC<Props> = () => {

    const { classificationListStatus, completeStep } = glClassificationApi();
    const navigate = useNavigate();

    const branchData = useSelector(getBranch)
    const userStepStatus = useSelector(getFirstLoginStatus);

    const [records, setRecords] = useState<any | null>(null);
    const [months, setMonths] = useState<any | null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [ userStepCompleted, setUserStepCompleted ] = useState<number>(userStepStatus);
    const [contentMaxHeight, setContentMaxHeight] = useState<number>(0);

    useEffect(() => {
        const months = MONTHS.reduce((a: any, c: any) => {
            a = {
                ...a,
                [+c['value']]: c['label']
            }
            return a;
        }, {})
        setMonths(months);

        fetchList();
    }, [])
    useEffect(() => {
        setUserStepCompleted(userStepStatus)
    }, [userStepStatus])

    const fetchList = () => {
        setIsLoading(true);
        classificationListStatus({ account_type: 1, branch_id: +branchData['id'] }, (message: string, resp: any) => {
            setIsLoading(false);
            setRecords(resp.data.data.transactions);
        }, (message: string, resp: any) => {
            setIsLoading(false);
            toast.error(message);
        })
    }

    const completeCurrentStep = () => {
        setIsLoading(true);
        completeStep({ branch_id: +branchData['id'], type: 2, step: 2 }, (message: string, resp: any) => {
            setIsLoading(false);
            navigate(URLS.DASHBOARD)
        }, (message: string, resp: any) => {
            setIsLoading(false);
            toast.error(message);
        })
    }


    return (
        <div className="main-container flex-grow-1">
            <div className="container-fluid">
                <div className="pb-4 pt-3" id="ux_page_title">
                    <div className="row align-items-center">
                        <div className="col-sm-6 page-title align-items-center d-flex">
                            <h1 className="h3 font-weight-700 mb-0 d-inline-flex">Expense Classification Status</h1>
                        </div>
                        {/* <div className="col-sm-6 justify-content-end align-items-center d-flex">
                            <Link to={URLS.DASHBOARD} className="btn btn-link">Back To Dashboard</Link>
                        </div> */}
                    </div>
                </div>

                {
                    userStepCompleted < 2 && records && records.length == 0 ? (
                        <Alert variant={'info'}>
                            <i className="fa fa-exclamation-triangle fa-lg" aria-hidden="true"></i>&nbsp;&nbsp;
                            Please close a month in RevRex System for Bank Transactions in order to get Expense Data.
                        </Alert>
                    ) : userStepCompleted >= 3 && records && records.length == 0 ? (
                        <Alert variant={'info'}>
                            <i className="fa fa-exclamation-triangle fa-lg" aria-hidden="true"></i>&nbsp;&nbsp;
                            You have nothing to classify here. Please go back to dashboard.
                        </Alert>
                    ) : <></>
                }

                <div className=" executive-dashboard">
                    <div className="dashboard-top-part">
                        <div className={`page-loader ${isLoading ? 'visible' : ''}`}>
                            <div className="loader"></div>
                        </div>
                        <div className="table-responsive list-table table-scroll">
                            <table className="table table-default">
                                <thead>
                                    <tr className="align-middle">
                                        <th className="text-center">Month</th>
                                        <th className="text-center">Year</th>
                                        <th className="text-center">Status </th>
                                        <th className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        records && records.map((data: any, index: number) => (
                                            <tr className="align-middle h-60" key={index}>
                                                <td className="text-center">
                                                    {months[data['item']['month']]}
                                                </td>
                                                <td className="text-center">
                                                    {data['item']['year']}
                                                </td>
                                                <td className="text-center">
                                                    <h6>
                                                        {data['status'] == 'posted' ? <Badge bg="success">Completed</Badge> : data['status'] == 'partial_posted' ? <Badge bg="warning">Pending</Badge> : <Badge bg="warning">Pending</Badge>}
                                                    </h6>
                                                </td>
                                                <td className="text-center">
                                                    {
                                                        data['status'] != 'posted' && <Link to={`/expense-gl-classification/${data['item']['month']}/${data['item']['year']}`}>Click Here To Classify</Link> || <span>NA</span>
                                                    }
                                                </td>
                                            </tr>))
                                    }
                                    {
                                        records && records.length == 0 && (
                                            <tr>
                                                <td colSpan={4} className='text-center'>
                                                    <p>You have no records to classify.</p>
                                                    {
                                                        userStepCompleted < 3 && (
                                                            <button className='btn btn-cancel' onClick={completeCurrentStep}>Click here to skip this step</button>
                                                        ) || <></>
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                        {/* <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} recordPerPage={recordPerPage} lastIndex={lastIndex} firstIndex={firstIndex} npage={npage} /> */}
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ExpenseGlClassificationStatus;